//
// Layout Controller
//
// Creates and lays out objects using data from layout files
// Responds to orientation changes to select different layout
//

layoutController = {};
layoutController.layoutElements = {};
layoutController.layoutElementsKeys = [];
layoutController.newLayoutElementsKeysRequired = false;
layoutController.updateDisabled = false;
layoutController.updateRequired = false;

layoutController.createLayoutObjects = function (layoutJSON, resources) {
  var json;

  // Create all objects in the layout json
  for (var prop in layoutJSON) {
    if (layoutJSON.hasOwnProperty(prop)) {
      function loadAllChildren(
        children,
        parentContainer,
        parentName,
        resources
      ) {
        // Create objects for this container
        for (var i = 0; i < children.length; i++) {
          json = children[i];
          var create = true;
          if (json.create_if !== undefined) {
            create = resourceManager.evaluateCreateIf(json.create_if);
          }

          if (create) {
            var deserialisedObj = layoutController.create(
              json,
              parentContainer,
              parentName,
              resources
            );
            if (json.children && json.children.length !== 0) {
              var container = new PIXI.Container();
              deserialisedObj.addChild(container);
              loadAllChildren(
                json.children,
                container,
                deserialisedObj.Props.FQN,
                resources
              );
            }
          }
        }
      }

      if (layoutJSON[prop].children.length !== 0) {
        loadAllChildren(
          layoutJSON[prop].children,
          resourceManager.containers[prop],
          "",
          resources
        );
      }
    }
  }
};

layoutController.setOverrides = function (object) {
  // This function overrides function that would break the library layout system
  object.position.superSet = object.position.set;

  // Get/Set X/Y
  object.position.set = function (x, y) {
    this.superSet(
      x * resourceManager.selectedAssetResolution.scale,
      y * resourceManager.selectedAssetResolution.scale
    );
  };
  object.position.get = function () {
    return {
      x: this.x * resourceManager.selectedAssetResolution.scaleFactor,
      y: this.y * resourceManager.selectedAssetResolution.scaleFactor,
    };
  };

  // Get / Set X individually
  object.position.setX = function (x) {
    this.x = x * resourceManager.selectedAssetResolution.scale;
  };
  object.position.getX = function () {
    return this.x * resourceManager.selectedAssetResolution.scaleFactor;
  };

  // Get / Set Y individually
  object.position.setY = function (y) {
    this.y = y * resourceManager.selectedAssetResolution.scale;
  };
  object.position.getY = function () {
    return this.y * resourceManager.selectedAssetResolution.scaleFactor;
  };
};

layoutController.create = function (json, container, parentName, resources) {
  var thisName =
    parentName !== undefined && parentName !== "" ? parentName + ":" : "";
  thisName += json.ID;
  json.parentID = parentName;
  json.FQN = thisName;

  // Check we have a creation function associated with this resource type
  if (typeof resourceManager.typeCreationFunctions[json.type] === "undefined") {
    console.error("Unknown type - " + json.type);
    return;
  }

  if (typeof resourceManager.generatedResources[thisName] !== "undefined") {
    console.error("Already created resource " + thisName);
    return;
  }

  // Create the object
  try {
    // We wrap this up because this calls code outside the libraries
    var object = resourceManager.typeCreationFunctions[json.type](json);
    object.name = json.FQN;
  } catch (error) {
    console.log("Error when trying to create object '" + json.ID + "'");
    console.log(error.stack);
  }

  if (typeof object === "undefined") {
    console.error(
      "Object creation function for " +
        json.type +
        " returned an undefined object"
    );
    return;
  }

  // Add object to PIXI hierarchy
  container.addChild(object);

  resourceManager.generatedResources[thisName] = {
    object: object,
    params: json,
  };

  var keys = Object.keys(resourceManager.configuration.layouts);
  for (var i = 0; i < keys.length; i++) {
    var layoutName = keys[i];
    if (checkForUndefined(json[layoutName])) {
      // No layout defined, so is there a default?
      if (checkForDefined(json.default)) {
        // yes, so use this
        json[layoutName] = json.default;
      } else {
        // No, so create a default layout
        json[layoutName] = { position: { x: 0, y: 0 } };
      }
    }
  }

  // this bit compares all the layouts looking for differences
  // uses simple string compares - not 100% but good enough i think
  let diff = false;
  for (let k = 0; k < keys.length - 1 && !diff; k++) {
    for (let l = k + 1; l < keys.length && !diff; l++) {
      const string1 = JSON.stringify(json[keys[k]]);
      const string2 = JSON.stringify(json[keys[l]]);
      if (string1 !== string2) {
        diff = true;
      }
    }
  }

  if (diff === true) {
    // there is some differences here so save the data in layoutElements which updateLayout
    // will be using now, instead of resourceManager.generatedResources
    layoutController.layoutElements[thisName] = {
      object: object,
      params: json,
    };
    layoutController.newLayoutElementsKeysRequired = true;
  }

  // Allow developers to access the properties that created this object.
  object.Props = json;

  // Set overrides for this object
  layoutController.setOverrides(object);

  // Now we have created the object, initialise it
  try {
    // We wrap this up because this calls code outside the libraries
    resourceManager.typeInitialiseFunctions[json.type](json, object, resources);
  } catch (error) {
    console.log("Error when trying to initialise object '" + json.ID + "'");
    console.log(error.stack);
  }

  // Update this object so it's correct when the layout shows.
  var layout = layoutController.getCurrentLayout();
  var resource = resourceManager.generatedResources[object.Props.FQN];
  var parameters = resource.params[layout];
  layoutController.updateObjectLayout(
    resource,
    parameters,
    resourceManager.selectedAssetResolution.scaleFactor
  );

  // Everything created successfully
  return object;
};

layoutController.getCurrentLayoutProperties = function () {
  return resourceManager.getConfiguration()["layouts"][
    layoutController.getCurrentLayout()
  ];
};

layoutController.getCurrentPosition = function (resourceName) {
  return resourceManager.generatedResources[resourceName].params[
    layoutController.getCurrentLayout()
  ].position;
};

layoutController.getCurrentLayout = function () {
  // Select layout
  var keys = Object.keys(resourceManager.configuration.layouts);
  for (var i = 0; i < keys.length; i++) {
    var layout = resourceManager.configuration.layouts[keys[i]];
    if (layout.landscape === systemData.isLandscape) {
      // Same orientation, so check mobile
      if (layout.mobile === gdk.deviceInfo.mobile) {
        if (layout.mapped !== undefined) {
          return layout.mapped;
        }

        return keys[i];
      }
    }
  }

  // No exact match, so use first layout available
  return keys[0];
};

layoutController.updateLayout = function () {
  if (layoutController.updateDisabled !== true) {
    if (layoutController.newLayoutElementsKeysRequired === true) {
      layoutController.layoutElementsKeys = Object.keys(
        layoutController.layoutElements
      );
      layoutController.newLayoutElementsKeysRequired = false;
    }

    // Orientation / Device
    const layout = layoutController.getCurrentLayout();
    const keys = layoutController.layoutElementsKeys;

    for (let i = 0; i < keys.length; i++) {
      const prop = keys[i];
      const resource = layoutController.layoutElements[prop];
      const parameters = resource.params[layout];

      layoutController.updateObjectLayout(
        resource,
        parameters,
        resourceManager.selectedAssetResolution.scaleFactor
      );
      resource.object.Props[layout] = parameters;
    }

    // If we change the layout, update the screen
    //Reflex.doSingleRender();
    layoutController.updateRequired = false;

    for (let i = 0; i < Reflex.EventCallbacks.layoutChange.length; i++) {
      Reflex.EventCallbacks.layoutChange[i]();
    }
  }
};

layoutController.updateObjectLayout = function (resource, parameters, scale) {
  if (typeof parameters === "undefined") {
    parameters = { position: { x: 0, y: 0 } };
  }

  // Position object
  if (typeof parameters.position === "undefined") {
    parameters.position = { x: 0, y: 0 };
  }

  // Call root object superset if exists (we always want to use PIXI)
  if (resource.object.position.superSet) {
    // This is a managed object
    resource.object.position.superSet(
      parameters.position.x / scale,
      parameters.position.y / scale
    );
  } else {
    // This is a non managed object (i.e. container)
    resource.object.position.set(
      parameters.position.x / scale,
      parameters.position.y / scale
    );
  }

  // Default scale values
  if (checkForUndefined(parameters.scale)) {
    parameters.scale = 1;
  }
  if (checkForUndefined(parameters.scaleX)) {
    parameters.scaleX = parameters.scale;
  }

  if (checkForUndefined(parameters.scaleY)) {
    parameters.scaleY = parameters.scale;
  }

  // Scale object
  resource.object.scale.x = parameters.scaleX;
  resource.object.scale.y = parameters.scaleY;

  if (resource.object.Props.type === "text") {
    // Text objects need to check max width if they change scale
    resource.object.checkBounds(
      resource.object.Props[layoutController.getCurrentLayout()].scale
    );
  }

  // Rotate object (if defined)
  if (checkForDefined(parameters.rotation)) {
    resource.object.rotation = parameters.rotation;
  }

  if (checkForDefined(parameters.alpha)) {
    resource.object.alpha = parameters.alpha;
  }

  // Object visibility
  if (checkForDefined(parameters.visible)) {
    resource.object.visible = parameters.visible;
  }
};

layoutController.initialise = function () {
  Reflex.registerEventHandler(
    "orientationChange",
    layoutController.onOrientationChange
  );

  messageBus.subscribe("game:goingToReplay", layoutController.goingToReplay);
  messageBus.subscribe("game:backFromReplay", layoutController.backFromReplay);
};

layoutController.goingToReplay = function (task) {
  layoutController.updateDisabled = true;
};

layoutController.backFromReplay = function (task) {
  layoutController.updateDisabled = false;
  // layoutController.updateLayout();
  messageBus.post("layoutController:backFromReplay", {}); // left in for backwards compat
};

layoutController.onOrientationChange = function () {
  if (typeof resourceManager.configuration !== "undefined") {
    // Only update layout once we have loaded. Logical coordinates and layout are also set once layout file is loaded.
    var layout =
      resourceManager.configuration.layouts[
        layoutController.getCurrentLayout()
      ];
    Reflex.setLogicalCoordinates(layout.width, layout.height);
    layoutController.updateLayout();
  }
};
